const Environment = {
    PROD: "prod",
    TEST: "test",
    UAT: "uat",
    DEMO: "demo",
    DEV: "dev",
    DEFAULT: "default"
}

export default Environment
